import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/investigator/detail',
      name: 'doctorConcern',
      component: resolve => require(['../components/doctorConcern.vue'], resolve)
    },
    {
      path: '/trial/detail',
      name: 'trialDetail',
      component: resolve => require(['../components/trialDetail.vue'], resolve)
    },
    {
      path: '/organization/sign_log',
      name: 'personalTrajectory',
      component: resolve => require(['../components/personalTrajectory.vue'], resolve)
    },
    {
      path: '/organization/detail',
      name: 'researcherCenter',
      component: resolve => require(['../components/researcherCenter.vue'], resolve)
    },
    {
      path: '/organization/sign_statistics',
      name: 'signInList',
      component: resolve => require(['../components/signInList.vue'], resolve)
    },
    {
      path: '/duration',
      name: 'duration',
      component: resolve => require(['../components/duration.vue'], resolve)
    },
    {
      path: '/tnm',
      name: 'tnm',
      component: resolve => require(['../components/tnm.vue'], resolve)
    },
    {
      path: '/user/license',
      name: 'userLicense',
      component: resolve => require(['../components/userLicense.vue'], resolve)
    },
    {
      path: '/freelance/license',
      name: 'freelanceLicense',
      component: resolve => require(['../components/freelanceLicense.vue'], resolve)
    },
    {
      path: '/article/equity',
      name: 'article',
      component: resolve => require(['../components/articleEquity.vue'], resolve)
    },
    {
      path: '/article/equity/:article_id',
      name: 'articleEquityDetail',
      component: resolve => require(['../components/articleEquityDetail.vue'], resolve)
    },
    {
      path: '/sudu',
      name: 'sudu',
      component: resolve => require(['../components/sudu.vue'], resolve)
    },
    {
      path: '/sudu/:article_id',
      name: 'suduDetail',
      component: resolve => require(['../components/suduDetail.vue'], resolve)
    },
    {
      path: '/mobile_version',
      name: 'mobile',
      component: resolve => require(['../components/mobile.vue'], resolve)
    },
    {
      path: '/',
      name: 'index',
      component: resolve => require(['../page/noFoundPage/noFoundPage.vue'], resolve)
    },
    {
      path: '*',
      name: 'noFoundPage',
      component: resolve => require(['../page/noFoundPage/noFoundPage.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js